<template>
  <div class="right-body" id="rightBodyList" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)" @click="filterMenuClose">
    <div v-show="haveTaskData==1" class="right-body-box" v-loading="deleteloading" element-loading-background="rgba(0, 0, 0, 0.05)">
      <div class="right-task-list">
        <div class="task-list-title">
          <div class="list-des-position">
            <div class="title-des">{{$t('language.leftBanner.taskList')}}</div>
            <div>{{$t('language.taskList.taskListDes')}}</div>
          </div>
          <div class="task-list-icons" v-if="allTaskData.length>5"  v-clickoutside="filterMenuClose" v-rightclickoutside="dateControlsClose">
            <div class=" task-list-edit-position" @click.stop="eidtTaskFlag=!eidtTaskFlag" :class="eidtTaskFlag?'icon-util task-list-edit-forbid ':'task-list-edit '"></div>
            <div class="icon-util funnel" @click.stop="filterMenuShow=true"></div>
            <div class="filter-menu" v-show="filterMenuShow">
              <div class="filter-menu-item" @mouseenter="switchMenu(index)" @click.stop="switchMenu(index)" v-for="(filterType, index) in filterArr" :key="index">
                <div class="icon-util filter-triangle filter-triangle-position"></div>
                {{filterType}}
              </div>
            </div>
            <!-- 筛选条件 -->
            <!-- type -->
            <div class="type-menu" v-if="filterIndex==0">
              <div class="type-menu-item" :class="{'type-menu-checked':typeClick==index}" v-for="(typeItem, index) in typeArr" :key="index" @click.stop="selectTypeFilters(typeItem, index)">
                <div class="icon-util tick-purple-position" :class="{'tick-purple':typeClick==index}"></div>
                <div class="filter-type-name">{{typeItem}}</div>
              </div>
            </div>
            <!-- date -->
            <div class="type-menu" v-show="filterIndex==1">
              <div class="type-menu-item" :class="{'type-menu-checked':dateClick==index}" v-for="(dateItem, index) in dateArr" :key="index" @click.stop="selectDateFilters(dateItem, index)">
                <div class="icon-util tick-purple-position" :class="{'tick-purple':dateClick==index}"></div>
                <div class="filter-type-name">{{dateItem}}</div>
              </div>
            </div>
            <!-- status -->
            <div class="type-menu" v-if="filterIndex==2">
              <div class="type-menu-item" :class="{'type-menu-checked':statusClick==index}" v-for="(statusItem, index) in statusArr" :key="index" @click.stop="selectStatusFilters(statusItem, index)">
                <div class="icon-util tick-purple-position" :class="{'tick-purple':statusClick==index}"></div>
                <div class="filter-type-name">{{statusItem}}</div>
              </div>
            </div>
            <div class="time-set" v-if="timeSetShow" @click.stop="reSet()" v-clickoutside="dateControlsClose">
              <date-selector ref="minDate" @changeDate="changeMinDate" style="margin:8Px 8Px 8Px 10Px;/*no*/">
              </date-selector>
              <div class="icon-util arrow-purple arrow-purple-position"></div>
              <date-selector ref="maxDate" @changeDate="changeMaxDate" style="margin:8Px 19Px 8Px 8Px;/*no*/">
              </date-selector>
              <button class="time-set-button" @click.stop="filterMenuOpen()">{{$t('language.common.ok')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="task-list-all">
        <div    :class="eidtTaskFlag?'task-list-edit-contens':'task-list-contens'" v-cloak>
                <div ref="allcollapsebox"
                     :class="[collapseFlage==index&&detailShow&&(item.type==1||item.type==6)&&item.transferDetail?'single-from-collapse-box':'edit-all-box',collapseFlage==index&&detailShow&&item.type==2?'single-to-collapse-box':'']"
                     v-for="(item, index) in tasklistData" :key="item.id" @click="selectItem(item)"
                     :style="{height:getContectHeight(item,index)}">
                    
                     <singleTask ref="singleTask" :item=item :collapseFlage=collapseFlage :eidtTaskFlag='eidtTaskFlag' :detailShow=detailShow :index=index :tasklistData='tasklistData'> </singleTask>
                
                </div>
        </div>
      </div>
      <div class="eidt-task-bottom" v-if="eidtTaskFlag">
        <button class="select-all-button" id="allButton" @click.stop="selectAll()">
          <div class="icon-util white-tick" id="whiteTick"></div>
          <div class="icon-util purple-tick" id="purpleTick"></div>
          <div class="operate-option">{{$t('language.common.selectAll')}}</div>
        </button>

        <button class="task-delete-button" id="deleteButton" @click.stop="deleteAllItem()">
          <div class="icon-util white-fork  delete-one" id="whiteFork"></div>
          <div class="icon-util purple-fork  delete-two" id="purpleFork"></div>
          <div class="operate-option">{{$t('language.common.delete')}}</div>
        </button>

      </div>
      <deleteTaskDialog ref="deleteTaskDialog"></deleteTaskDialog>
      <deleteSelectedTaskDialog ref="deleteSelectedTaskDialog"></deleteSelectedTaskDialog>
      <upgradeNewDialog ref="upgradeNewDialog"></upgradeNewDialog>
      <noticeDialog ref="noticeDialog"></noticeDialog>
      <renameDialog ref="renameDialog"></renameDialog>
      <backupSourceFilesDialog ref="backupSourceFilesDialog"></backupSourceFilesDialog>
      <restoreAimMoreDialog ref="restoreAimMoreDialog"></restoreAimMoreDialog>
    </div>

    <div class="task-list-welcome" v-show="haveTaskData==2" v-loading="loading">
      <div class="welcome-opreation">
        <div class="welcome-task-list">{{$t('language.taskList.noTaskCreated')}}</div>
        <div class="welcome-task">
          <button class="welcome-task-button" @click="goToTransferPage()" :class="[$i18n.locale=='deutsch'?'deu-class':'',languaArr.includes($i18n.locale)?'other-language':'']">
            <div class="icon task-list-icon-position cloudTransfer"></div>
            <div class="welcome-font-position">{{$t('language.taskList.createTransferTask')}}</div>
          </button>
        </div>
        <div class="welcome-task">
          <button class="welcome-task-button" @click="goTeamTransferPage()" :class="[$i18n.locale=='deutsch'?'deu-class':'',languaArr.includes($i18n.locale)?'other-language':'']">
            <div class="icon task-list-icon-position teamTransfer"></div>
            <div class="welcome-font-position">{{$t('language.taskList.createTeamTransferTask')}}</div>
          </button>
        </div>
        <div class="welcome-task">
          <button class="welcome-task-button" @click="goToSyncPage()" :class="[$i18n.locale=='deutsch'?'deu-class':'',languaArr.includes($i18n.locale)?'other-language':'']">
            <div class="icon task-list-icon-position cloudsync"></div>
            <div class="welcome-font-position">{{$t('language.taskList.createSyncTask')}}</div>
          </button>
        </div>
         <div class="welcome-task">
          <button class="welcome-task-button" @click="goToBackupPage()" :class="[$i18n.locale=='deutsch'?'deu-class':'',languaArr.includes($i18n.locale)?'other-language':'']">
            <div class="icon task-list-icon-position cloudbackup"></div>
            <div class="welcome-font-position">{{$t('language.taskList.createBackupTask')}}</div>
          </button>
        </div>
        <div class="welcome-task">
          <button class="welcome-task-button" @click="goToRemotePage()" :class="[$i18n.locale=='deutsch'?'deu-class':'',languaArr.includes($i18n.locale)?'other-language':'']">
            <div class="icon task-list-icon-position linkTask"></div>
            <div class="welcome-font-position">{{$t('language.taskList.createRemoteTask')}}</div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import "@/assets/css/common_util.css";
import "@/assets/css/file_type.css";
import "@/assets/css/drive_type.css";
import dateSelector from "@/components/common/selector/date_selector";
//显示账号升级弹窗
import upgradeNewDialog from "@/components/popup/upgrade_popups/upgrade_account_new_popup";
import deleteTaskDialog from "@/components/popup/task_list_popups/delete_task_popups";
import deleteSelectedTaskDialog from "@/components/popup/task_list_popups/delete_selected_tasks_popups";
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
import noticeDialog from "@/components/popup/cloud_transfer_popups/transfer_notice_popup";
//单个任务信息
import singleTask from "@/components/common/tabs/tabs_task_list/tabs_single_task";
import renameDialog  from '@/components/popup/task_list_popups/task_rename_notice_popup';
import backupSourceFilesDialog from '@/components/popup/task_list_popups/files_to_backup_popup';
import restoreAimMoreDialog from '@/components/popup/task_list_popups/restore_aim_more_popup';
export default {
  name: 'taskList',
  components: {
    "date-selector": dateSelector,
    deleteTaskDialog,
    deleteSelectedTaskDialog,
    noticeDialog,
    upgradeNewDialog,
    singleTask,
    renameDialog,
    backupSourceFilesDialog,
    restoreAimMoreDialog
  },
  data: function () {
    return {
      languaArr: ['portuguese', 'france', 'spanish', 'italian','japanese','nederlands'],
      outDate: false,
      detailShow: false,
      percent: 0,
      speed: 0,
      threadChange: false, //用于子组件渲染界面
      transferDetailChange: false, //用于子组件渲染界面
      oldReadyBytes: 0,
      readyBytes: 0,
      inputValue: '',
      indexCurrent: -1,
      filterMenuShow: false,
      hoverCurrent: -1,
      clickCurrent: -1,
      openDetailCurrent: -1,
      operateMenuIndex: -1,
      collapseFlage: -1,
      filterIndex: null,
      filterClick: null,
      typeClick: 0,
      statusClick: 0,
      dateClick: 0,
      timeSetShow: false,
      eidtTaskFlag: false,
      checkSchedule: -1,
      isflage: true, //用于防止重复提交请求
      transferDetail: '',
      syncDetail: '',
      unfinishedArr: ["cancel", "partial success", "error"],
      tasklistData: [],
      filterArr: [this.$t('language.common.type'), this.$t('language.common.date'), this.$t(
        'language.common.status')],
      oldTaskName: '',
      typeArr: [
        this.$t('language.popup.allTasks'),
        this.$t('language.taskList.transferTasks'),
        this.$t('language.taskList.syncTasks'),
        this.$t('language.taskList.shareTasks'),
        this.$t('language.taskList.backupTasks'),
        this.$t('language.taskList.emailTransferTasks'),
      ],
      runningTaskId: '',
      dateArr: [
        this.$t('language.taskList.allTime'),
        this.$t('language.taskList.today'),
        this.$t('language.taskList.latestWeek'),
        this.$t('language.taskList.latestMonth'),
        this.$t('language.taskList.customDate')
      ],
      statusArr: [
        this.$t('language.taskList.allStatus'),
        this.$t('language.taskList.preset'),
        this.$t('language.common.running'),
        this.$t('language.common.success'),
        this.$t('language.common.patial'),
        this.$t('language.common.failed'),
        this.$t('language.common.canceled')
      ],
      showTypeArr: [],
      haveTaskData: 0,
      filterBy: {
        type: -1,
        date: -1,
        status: -1
      },
      allTaskData: [],
      haveFilterArr: [],
      minDate: null,
      maxDate: null,
      flag: true,
      t: '',
      loading: false,
      deleteloading: false,
      executeFlag: true,
      sortAllData: false,
      closeMentFlag: false,
      showUserStarTime: 0,
    };
  },
  inject: ["reload"],
  created () {
    //初始化任务管理界面
    this.inintTaskListPage();
    //var dropbox = document.getElementById('rightBodyList');
    // dropbox.addEventListener('dragenter', this.onDrag, false);
    // dropbox.addEventListener('dragover', this.onDrag, false);
    // dropbox.addEventListener('drop', this.onDrag, false);
  },
  watch: {
    tasklistData: { //监听的对象
      deep: true, //深度监听设置为 true
      handler: function (newV, oldV) {
        this.$forceUpdate();
        // 用户好评弹窗（在任务列表时判断是否要弹窗）
        // 处于任务列表界面
        if (this.$route.path == "/mc_project/task_list") {
          let user = commonUtils.getUser();
          // 新注册的用户
          if (user.createTime > 1700032515000) {
            // 是否要弹窗
            if (this.$store.state.isShowUserStar) {
              // 任务数大于1
              if (newV.length >= 1) {
                // 统计成功任务数
                var successCount = 0;
                for (var i=0; i<newV.length; i++) {
                  var task = newV[i];
                  if (task.result=="success" && task.status=="Done") {
                    successCount++;
                  } else if (task.result=="success" && task.branchType=="realtime") {
                    successCount++;
                  }
                }
                // 所有任务都成功
                if (successCount == newV.length) {
                  let that = this;
                  var now = Date.now();
                  this.showUserStarTime = now;
                  // 请求后端是否要弹窗
                  taskListUtils.canShowUserStarRequest(now,function(time,res){
                    if (that.showUserStarTime == time) {
                      // 要弹
                      if (res.isPop == true) {
                        that.$store.state.isShowUserStarReady = true;
                      } else {
                        that.$store.state.isShowUserStar = false;
                      }
                    }
                  });
                }
              }
            }
          }
        }
      }
    },
    //监听路由变化
    // '$route' (to, from) {
    //   this.$router.go(0);//刷新界面
    // },
    //监听任务列表数据
    '$store.state.taskListArr': function (newValue, oldValue) {
      if (!newValue.length) {
        //如果没有新数据就显示另一个界面
        this.haveTaskData = 2;
      } else {
        //显示任务列表
        this.haveTaskData = 1;
        this.tasklistData = Object.assign([], newValue);
        this.allTaskData = Object.assign([], this.tasklistData);
        this.switchDate(this.filterBy.date);
        this.switchType(this.filterBy.type);
        this.switchStatus(this.filterBy.status);
        this.$forceUpdate();
      }
    },
    //用于判断是否有添加新的临时任务数据
    '$store.state.haveNewSnapData': function (newValue, oldValue) {
      let that = this;
      //触发事件后，判断是否获取进度
      if (this.$store.state.newDataFlag && this.$store.state.loadFlag) { //说明有新数据,并且没有数据在获取进度，则此时获取进度
        commonUtils.runDetailProgressData(that);
      }
    },
    //监听过滤任务
    filterBy: {
      handler (newValue, oldValue) {
        this.tasklistData = Object.assign([], this.allTaskData);
        this.switchDate(newValue.date);
        this.switchType(newValue.type);
        this.switchStatus(newValue.status);
      },
      deep: true
    },
  },
  methods: {
    //初始化任务列表
    inintTaskListPage () {
    let that=this;
        that.tasklistData = Object.assign([], that.$store.state.taskListArr.sort(taskListUtils.sortCreateTime));
        //获取未分组的任务列表
        let allNotGropData = Object.assign([], this.$store.state.taskListNotGropArr); 
    },
    initTaskListRequest () {
      let that = this;
      taskListUtils.inintTaskList(function (res) {
        // if (res.status != 200 && res != 'fail') {//不等于fail表示进入了inintTaskList函数，但请求返回失败
        //   that.$toast({
        //     text: that.$t('language.exception.' + res.reason),
        //     type: 'fail',
        //     idValue: "rightBodyList"
        //   });
        //   return false;
        // }
        that.$store.state.taskListFlag = true;//把数据已成功加载置为真
        that.tasklistData = Object.assign([], that.$store.state.taskListArr.sort(taskListUtils.sortCreateTime)); //本页面的任务为store存储的任务
     //如果本页面没有数据，则将数据标志置为2，显示另一种样式
        if (!that.tasklistData.length) {
          that.haveTaskData = 2;
        }
      });
    },
    getContectHeight(item,index){
        let height;
        let flag = commonUtils.isVip();
        let boxHeight = 390;
        if (flag) {
            boxHeight = 350;
        } else {
            boxHeight = 390;
        }
        if((item.type==1)&&this.collapseFlage==index&&this.detailShow&&item.transferDetail&&item.transferDetail.entities){
            height=item.transferDetail.entities.length*25+boxHeight+'Px';
        }
         if((item.type==6)&&this.collapseFlage==index&&this.detailShow&&item.transferDetail&&item.transferDetail.stateSet){
              height=item.transferDetail.stateSet.length*25+boxHeight+'Px';
        }
         if(item.type==2 && this.collapseFlage!=index){
            height=95+'Px';
        }
        if(!height&&item.type==2 && this.collapseFlage==index && item.sources){
            if(this.$refs.allcollapsebox){
                  height =  this.$refs.allcollapsebox[index].style.height;
            }
        }
        return height;

    },
    //禁用拖拽事件
    onDrag: function (e) {
      e.stopPropagation();
      e.preventDefault();
    },
    //时间倒序排列
    sortCreateTime (a, b) {
      if (a && b)
        return -(a.createTime - b.createTime);
    },
    //筛选数据
    switchDate (index) {
      let that = this;
      switch (index) {
        case 1:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return that.conversionTime(item.createTime) == that.conversionTime(new Date());
          });
          break;
        case 2:
          this.tasklistData = this.tasklistData.filter(function (item) {
            let lastestWeek = that.conversionTime(new Date() - 7 * 24 * 3600 * 1000);
            return item.createTime >= that.conversionLongTime(lastestWeek);
          });
          break;
        case 3:
          this.tasklistData = this.tasklistData.filter(function (item) {
            let LatestMonth = that.conversionTime(new Date().setMonth(new Date().getMonth() - 1));
            return item.createTime >= that.conversionLongTime(LatestMonth);
          });
          break;
        case 4: //出现自定义弹框
          this.filterMenuClose();
          this.timeSetShow = true;
          break;
      }

    },
    //根据类型筛选数据
    switchType (index) {
      
      let that = this;
      switch (index) {
        case 1:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 1 && !item.options.way && item.branchType == 'transfer';
          });
          break;
        case 2:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 2;
          });
          break;
        case 3:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 1 && item.branchType == 'share';
          });
          break;
        case 4:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 6;
          });
          break;
        case 5:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 1 && item.options.way == "cloudEmail" && item.branchType == 'transfer';
          });
          break;
        case 6:
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.type == 'url';
          });
          break;
      }
    },
    getTasklistHeight(item,index){
       var height=null;
      if ((item.type==1||item.type==6)&& this.collapseFlage==index&&this.detailShow&&item.transferDetail&&item.transferDetail.entities){
         height = (item.transferDetail.entities.length)*25+350+'Px';
      }
      return height;
    },
    //根据状态筛选数据
    switchStatus (index) {
      let that = this;
      //关闭所打开的界面
      var allItem = that.$refs.singleTask;
      if(allItem){
      for(var i = 0; i < allItem.length;i++ ){
         if( allItem[i].$refs.syncThread && allItem[i].$refs.syncThread.closePage()){
             allItem[i].$refs.syncThread.closePage();
         };
        }
      }
      that.detailShow=false;
      that.collapseFlage = -1;
      switch (index) {
        case 1://显示预设状态
          this.tasklistData = this.tasklistData.filter(function (item) {
            return item.status == 'Normal' && item.result != 'cancel'  && item.result != 'Run' && item.result != 'success' && item
              .result != 'error';
          });
           this.$forceUpdate();
          break;
        case 2://显示运行状态的任务
          this.tasklistData = this.tasklistData.filter(function (item) {
            if (item.type == 1&&item.branchType!='cloudEmailTransfer') {
              return taskListUtils.showTransferRunning(item);
            }else if (item.type == 6) {
              return taskListUtils.showBackupRunning(item);
            } else {
              if (item.sources) {
                return taskListUtils.showSyncSourceRunning(item);
              } else {
                return taskListUtils.showSyncSingleRunning(item);
              }
            }
          });
           this.$forceUpdate();
          break;
        case 3://显示成功状态的任务
          this.tasklistData = this.tasklistData.filter(function (item, index) {
            if(item.branchType == 'realtime'){
                return;
            }
            if (!item.sources) {
              return taskListUtils.showSuccessStatus(item);
            } else {
              return taskListUtils.showSourceSuccessStatus(item);
            }
          });
           this.$forceUpdate();
          break;
        case 4://显示部分成功的任务
          this.tasklistData = this.tasklistData.filter(function (item, index) {
             if(item.branchType == 'realtime'){
                return;
            }
            if (!item.sources) {
              return taskListUtils.showpartialStatus(item);
            } else {
              return taskListUtils.showSourcepartialStatus(item);
            }
          });
           this.$forceUpdate();
          break;
        case 5: //显示失败状态的任务
          this.tasklistData = this.tasklistData.filter(function (item, index) {
             if(item.branchType =='realtime'){
                return;
            }
            if (!item.sources) {
              if(item.type==6 && item.result == 'error'){
                return true;
              }
              return item.result == 'error' && ((item.errorFileCount / item.totalFileCount) * 100 > 20);
            } else {
              //如果是多源或多目标同步失败
              return taskListUtils.showSwitchSourcesFailureStatus(item);
            }
          });
           this.$forceUpdate();
          break;
        case 6: //显示取消的任务
          this.tasklistData = this.tasklistData.filter(function (item) {
            if(item.branchType == 'realtime'){
                return;
            }
            return (taskListUtils.showCancelStatus(item) || item.cancelStatus);
          });
           this.$forceUpdate();
          break;
      }
      this.$forceUpdate();
    },
    //获取最小时间
    changeMinDate (newDate) {
      this.minDate = newDate;
    },
    //获取最大时间
    changeMaxDate (newDate) {
      this.maxDate = newDate;
    },
    //关闭过滤菜单
    filterMenuClose () {
      this.filterMenuShow = false;
      this.filterIndex = null;
    },
    //打开过滤菜单
    filterMenuOpen () {
      let that = this;
      this.tasklistData = Object.assign([], this.allTaskData);
      this.switchStatus(this.filterBy.status);
      this.switchType(this.filterBy.type);
      let min = that.conversionLongTime(this.minDate);
      let max = that.conversionLongTime(this.maxDate);
      let maxLongAdd = that.conversionMaxLongTime(this.maxDate);
      if (min > max) {
        this.$toast({
          text: that.$t('language.taskList.timeMustLess'),
          type: 'fail',
          idValue: "rightBodyList"
        });
      } else {
        this.tasklistData = this.tasklistData.filter(function (item) {
          return item.createTime >= min && item.createTime < maxLongAdd;
        });
      }
      this.dateClick = 4;
    },
    dateControlsClose () {
      this.timeSetShow = false;
    },
    switchMenu (index) {
      this.filterIndex = index;
    },
    //重置时间选择
    reSet () {
      this.$refs.minDate.checkYear = false;
      this.$refs.minDate.checkMonth = false;
      this.$refs.minDate.checkDay = false;
      this.$refs.maxDate.checkYear = false;
      this.$refs.maxDate.checkMonth = false;
      this.$refs.maxDate.checkDay = false;
    },
    //获取状态过滤参数
    selectStatusFilters (statusItem, index) {
      this.statusClick = index;
      this.filterBy.status = index;
    },
    //获取日期过滤参数
    selectDateFilters (dateItem, index) {
      if (index == 4) {
        this.filterMenuClose();
        this.timeSetShow = true;
      } else {
        this.dateClick = index;
        let that = this;
        this.filterBy.date = index;
      }
    },
    //转换时间格式
    conversionTime (time) {
      var date = new Date(time);
      let year = date.getFullYear();
      let Month = date.getMonth() + 1;
      let day = date.getDate();
      let res = year + '-' + Month + '-' + day;
      return res;
    },
    //把时间转换为long类型
    conversionLongTime (time) {
      var date = new Date(time);
      let res = date.getTime();
      return res;
    },
    conversionMaxLongTime (time) {
      var date = new Date(time);
      date.setDate(date.getDate() + 1);
      let res = this.conversionLongTime(date);
      return res;
    },
    //获取过滤类型
    selectTypeFilters (typeItem, index) {
      this.typeClick = index;
      this.filterBy.type = index;
    },
    //跳转到传输界面
    goToTransferPage () {
      let that = this;
      $.each(that.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          that.$parent.$children[i].menuOptionSelect(101);
        }
      })
      this.$router.push({
        name: "cloudTransfer"
      });
    },
       //跳转到企业云盘传输界面
    goTeamTransferPage () {
      let that = this;
      $.each(that.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          that.$parent.$children[i].menuOptionSelect(102);
        }
      })
      this.$router.push({
        name: "teamTransfer"
      });
    },
    //跳转到同步界面
    goToSyncPage () {
      let that = this;
      $.each(that.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          that.$parent.$children[i].menuOptionSelect(103);
        }
      });
      this.$router.push({
        name: "cloudSync"
      });
    },
     //跳转到云备份界面
    goToBackupPage () {
      let that = this;
      $.each(that.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          that.$parent.$children[i].menuOptionSelect(104);
        }
      });
      this.$router.push({
        name: "cloudBackup"
      });
    },
    //跳转到离线任务界面
    goToRemotePage () {
      let that = this;
      $.each(that.$parent.$children, function (i, item) {
        if (item.menuOptions) {
          that.$parent.$children[i].menuOptionSelect(105);
        }
      })
      this.$router.push({
        name: "remoteTask"
      });
    },
    //选中一个任务
    selectItem (item) {
      if( !this.eidtTaskFlag){
          return;
      }
      if (this.$store.state.taskListSelectedArr.includes(item)) {
        this.$store.state.taskListSelectedArr = this.$store.state.taskListSelectedArr.filter(function (ele) {
          return ele != item;
        });
      } else {
        this.$store.state.taskListSelectedArr.push(item);
      }
    },
    //选中所有任务
    selectAll () {
       if( !this.eidtTaskFlag){
          return;
      }
      if (this.$store.state.taskListSelectedArr.length == this.tasklistData.length) {
        this.$store.state.taskListSelectedArr = [];
      } else {
        this.$store.state.taskListSelectedArr = this.tasklistData;
      }
    },
    //打开删除所有任务弹窗
    deleteAllItem () {
      this.$refs.deleteSelectedTaskDialog.deleteSelectedTaskShow = true;
      this.$refs.deleteSelectedTaskDialog.selectedItems = this.$store.state.taskListSelectedArr;
    }, 
  }, 
  filters: {
    ellipsis (value) {
      if (!value) return '';
      if (value.length > 39) {
        return value.slice(0, 39) + '...';
      }
      return value;
    },

  }
};

</script>

<style scoped>
@-webkit-keyframes rotation {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}

.Rotation {
  -webkit-transform: rotate(360deg);
  animation: rotation 3s linear infinite;
  -moz-animation: rotation 3s linear infinite;
  -webkit-animation: rotation 3s linear infinite;
  -o-animation: rotation 3s linear infinite;
}

.task-list-welcome {
  position: relative;
  width: 100%;
  height: 100%;
}

.welcome-opreation {
  position: absolute;
  width: 400Px;
  /*no*/
  height: 550Px;
  /*no*/
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.task-shedule-position {
  position: relative;
  top: 3Px;
  /*no*/
}

.welcome-task-list {
  text-align: center;
  font-size: 28Px !important;
  /*no*/
  margin-bottom: 65Px;
  /*no*/
}

.welcome-task {
  position: relative;
  width: 100%;
  height: 50Px;
  /*no*/
  margin-top: 40Px;
  /*no*/
}

.welcome-task-button {
  width: 250Px;
  /*no*/
  height: 40Px;
  /*no*/
  font-size: 16Px;
  /*no*/
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  line-height: 40Px; /*no*/
}

.list-des-position {
  float: left;
  position: relative;
  top: -10Px; /*no*/
}

.title-des {
  font-size: 18Px; /*no*/
  font-weight: bold;
  position: relative;
  top: -5Px; /*no*/
  color: #000;
}

.task-list-icon-position {
  float: left;
  top: 8Px; /*no*/
  position: relative;
}

.welcome-font-position {
  float: left;
  margin-left: 10Px;
  /*no*/
}

.transfer-operate {
  height: 35Px;
  /*no*/
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.tick-purple-position {
  float: left;
  position: relative;
  top: 10Px;
  /*no*/
  left: 17Px;
  /*no*/
  width: 15Px;
  /*no*/
  height: 15Px;
  /*no*/
}

.list-title-name {
  float: left;
  max-width: 160Px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.filter-menu {
  position: absolute;
  z-index: 600;
  background: #fff;
  width: 100Px;
  /*no*/
  height: 100Px;
  /*no*/
  border: 1Px solid #8a96e3;
  /*no*/
  right: 0;
}

.share-button {
  float: right !important;
}

.filter-menu-item {
  width: 100%;
  height: 33.3Px;
  /*no*/
  line-height: 33Px;
  /*no*/
}

.type-menu-item {
  width: 100%;
  height: 34Px;
  /*no*/
  line-height: 34Px;
  /*no*/
  position: relative;
}

.type-menu-checked {
  background: #d9e7ff;
}

.filter-triangle-position {
  position: relative;
  top: 6Px;
  /*no*/
  margin-right: 10Px;
  /*no*/
}

.filter-menu-item:hover,
.type-menu-item:hover,
.operate-menu-item:hover {
  background: #d9e7ff;
  cursor: pointer;
}

.filter-type-name {
  margin: 0 10Px 0 25Px;
  /*no*/
  float: left;
}

.transfers-to-catelogs {
  position: absolute;
  z-index: 3;
  width: 110Px;
  /*no*/
  height: 90Px;
  /*no*/
  border: 1Px solid #8a96e3;
  /*no*/
  background: #fff !important;
  top: 0Px;
  /*no*/
  overflow: auto;
}

.task-operating-menu {
  position: relative;
  float: right;
  top: 4Px;
  /*no*/
  margin-left: 15Px;
  /*no*/
}

.share-list-button {
  float: right;
  position: relative;
  top: 2Px;
  /*no*/
  font-size: 14Px;
  /*no*/
  border-radius: 2Px;
}


.transfers-status {
  float: left;
  width: 13%;
  /*no*/
  font-size: 14Px;
  /*no*/
  color: #6f7886;
  height: 100%;
  /*no*/
  line-height: 95Px;
  /*no*/
  min-width: 85Px;
  /*no*/
  margin-left: 0.7%;
  /*no*/
  position: relative;
}

.right-task-list {
  height: 100Px;
  /*no*/
  width: 95%;
  float: left;
  background-color: #f2f7fe;
  padding: 0 2% 0 2%;
  /*no*/
  position: relative;
}

.task-list-title {
  font-size: 14Px;
  /*no*/
  color: #6f7886;
  position: absolute;
  top: 0;
  bottom: 0;
  height: 14Px;
  /*no*/
  width: 96%;
  margin: auto;
  float: left;
}

.task-list-icons {
  height: 20Px;
  /*no*/
  float: right;
  cursor: pointer;
}

.task-list-contens {
  float: left;
  width: 100%;
  height: 100%;
  /*no*/
  box-sizing: border-box;
  padding: 0 2% 0 2%;
  /*no*/
  min-width: 1160Px;
  /*no*/
  overflow-y: overlay;
  overflow-x: hidden;
}

.task-list-all {
  width: 100%;
  height: calc(100% - 100Px);
  /*no*/
  overflow-y: hidden;
  overflow-x: hidden;
}

.task-list-edit-contens {
  float: left;
  width: 100%;
  height: calc(100% - 100Px) !important;
  /*no*/
  box-sizing: border-box;
  padding: 0 27Px 0 27Px;
  /*no*/
  min-width: 1167Px;
  /*no*/
  overflow: auto;
}

.list-node-name {
  color: #4281ff;
  max-width: 220Px !important;
  /*no*/
  height: 20Px !important;
  /*no*/
  float: left;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

.right-body-box,
#taskLoading {
  width: 100%;
  height: 100%;
}

/*定义滑块，内阴影及圆角*/
.task-list-all::-webkit-scrollbar {
  width: 8Px;
  /*no*/
  height: 8Px;
  /*no*/
  background-color: #fff;
  position: absolute;
  z-index: 700;
}

.task-list-contens::-webkit-scrollbar,
.task-list-edit-contens::-webkit-scrollbar {
  width: 8Px;
  /*no*/
  height: 8Px;
  /*no*/
  background-color: #fff;
  position: absolute;
  z-index: 700;
}

.task-list-all::-webkit-scrollbar-thumb,
.task-list-edit-contens::-webkit-scrollbar-thumb,
.task-list-contens::-webkit-scrollbar-thumb {
  height: 1Px;
  /*no*/
  border-radius: 5Px;
  /*no*/
  background-color: #becae4;
  position: absolute;
  z-index: 700;
}

.list-radio-position {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.edit-all-box {
  width: 100%;
  height: 95Px;
  /*no*/
  position: relative;
  margin-bottom: 10Px;
  /*no*/
  float: left;
}

.task-list-box {
  width: 100%;
  height: 95Px;
  /*no*/
  border: 1Px solid #becae4;
  /*no*/
  background: #fff;
  position: relative;
  float: right;
  margin-bottom: 10Px;
  /*no*/
}

.single-from-collapse-box {
  width: 100%;
  height: 410Px;
  /*no*/
  position: relative;
  margin-bottom: 10Px;
  /*no*/
  float: left;
}

.single-to-collapse-box {
  width: 100%;
  height: 320Px;
  /*no*/
  position: relative;
  margin-bottom: 10Px;
  /*no*/
}

.task-list-edit-box {
  width: calc(100% - 45Px) !important;
  /*no*/
  height: 95Px;
  /*no*/
  border: 1Px solid #becae4;
  /*no*/
  background: #fff;
  position: relative;
  float: right;
}

.singletask-collapse-box {
  width: 100%;
  height: 320Px;
  /*no*/
  border: 1Px solid #becae4;
  /*no*/
  background: #fff;
  position: relative;
  float: right;
}

.task-list-back {
  width: calc(100% - 10Px);
  /*no*/
  height: 85Px;
  /*no*/
  position: absolute;
  top: 0;
  bottom: 0;
  margin: 5Px 0Px 5Px 5Px;
  /*no*/
}

.task-list-backgroud {
  background: #e5f0ff;
  height: 100%;
}

.task-list-transfers-detail {
  position: absolute;
  top: 110Px;
  /*no*/
  width: 100%;
}

.task-lists-info {
  width: 100%;
  height: 95Px;
  /*no*/
  box-sizing: border-box;
  padding: 0 20Px 0Px 20Px;
  /*no*/
  float: left;
  position: absolute;
}

.task-lists-position {
  position: relative;
  top: 20Px;
  /*no*/
}


.transfer-type {
  float: left;
  width: 70Px;
  /*no*/
  height: 100%;
  /*no*/
  margin-right: 1.5%;
  /*no*/
}


.tasks-type {
  line-height: 50Px;
  /*no*/

  font-size: 14Px;
  /*no*/
}

.tasks-destion {
  font-size: 12Px;
  /*no*/
  color: #929ba9;
  height: 20Px;
  /*no*/
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 20Px;
  /*no*/
}

.tasks-shedule {
  font-size: 12Px;
  /*no*/
  color: #929ba9;
  position: absolute;
  bottom: 20Px;
  /*no*/
  margin: auto;
  white-space: nowrap;
}

.tasks-to-destion {
  height: 20Px;
  /*no*/
  font-size: 12Px;
  /*no*/
  color: #929ba9;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  line-height: 20Px;
  /*no*/
}

.transfer-share-operating {
  float: right;
  width: calc(100% - 655Px);
  /*no*/
  height: 100%;
  /*no*/
  position: relative;
}

.transfer-edit-operating {
  float: right;
  min-width: 200Px;
  /*no*/
  height: 100%;
  /*no*/
  position: relative;
}

.transfer-editshare-operating {
  float: right;
  width: calc(100% - 708Px);
  /*no*/
  height: 100%;
  /*no*/
  position: relative;
}

.oprate-not-allowed {
  cursor: not-allowed;
}

.oprate-not-allowed:hover {
  cursor: not-allowed;
  background: #5166bd !important;
}

.tasks-icon-position {
  position: relative;
  top: 6Px;
  /*no*/
  margin-right: 5Px;
  /*no*/
}

.operation-result:hover {
  text-decoration: underline;
  cursor: pointer;
}

.edit-small-position {
  position: relative;
  top: 3Px;
  /*no*/
}


.transfers-to {
  margin-left: 44Px;
  /*no*/
}

.type-menu {
  min-width: 200Px;
  /*no*/
  border: 1Px solid #8a96e3;
  /*no*/
  position: absolute;
  background: #fff;
  right: 101Px;
  /*no*/
  z-index: 300 !important;
}

.time-set {
  width: 425Px;
  /*no*/
  height: 50Px;
  /*no*/
  position: absolute;
  z-index: 3;
  background: #fff;
  border: 1Px solid #8a96e3;
  /*no*/
  right: 0;
}

.arrow-purple-position {
  float: left;
  margin: 12Px 10Px;
  /*no*/
}

.time-set-button {
  margin-top: 10Px;
  /*no*/
}

.operate-menu {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: absolute;
  z-index: 3;
  border: 1Px solid #8a96e3;
  /*no*/
  width: 180Px; /*no*/

  background: #fff;
  right: 0;
  left: 10;
}

.operate-menu-item {
  width: 100%;
  height: 35Px;
  /*no*/
  line-height: 35Px;
  /*no*/
  position: relative;
}

.operate-menu-name {
  position: relative;
  left: 45Px;
  /*no*/
  color: #6f7886;
  font-size: 14Px;
  /*no*/
  float: left;
}

.operate-icon-position {
  position: absolute;
  margin: auto;
  left: 17Px;
  /*no*/
  top: 0;
  bottom: 0;
}

.eidt-task-bottom {
  background: #fff;
  width: 100%;
  /*no*/
  height: 100Px;
  /*no*/
  position: absolute;
  top: calc(100% - 100Px);
  /*no*/
}

.select-all-button {
  position: absolute;
  top: 0;
  bottom: 0;
  float: left;
  margin: auto;
  left: 70Px;
  /*no*/
  height: 40Px;
  /*no*/
  font-size: 16Px;
  /*no*/
  background: #ecf0fe;
  color: #5562b4;
  border: 1Px solid #c6cefd;
  /*no*/
  margin-right: 15Px;
  /*no*/
  min-width: 118Px; /*no*/
  line-height: 20Px; /*no*/
}

.select-all-button:hover,
.task-delete-button:hover {
  background: #5562b4;
  color: #fff;
  border: 1Px solid #5562b4;
  /*no*/
  cursor: pointer;
}

.task-delete-button {
  position: absolute;
  top: 0;
  bottom: 0;
  float: left;
  margin: auto;
  left: 262Px;
  /*no*/
  height: 40Px;
  /*no*/
  background: #ecf0fe;
  color: #5562b4;
  font-size: 16Px;
  /*no*/
  border: 1Px solid #c6cefd;
  /*no*/
  min-width: 118Px; /*no*/
  line-height: 20Px; /*no*/
}

.task-list-edit-position {
  margin-right: 15Px;
  /*no*/
  float: left;
}

#purpleTick {
  display: block;
  float: left;
  margin-right: 10Px;
  /*no*/
}

#whiteTick {
  display: none;
  float: left;
  margin-right: 10Px;
  /*no*/
}

#purpleFork {
  display: block;
  float: left;
  margin-right: 10Px;
  /*no*/
}

#whiteFork {
  display: none;
  float: left;
  margin-right: 10Px;
  /*no*/
}

#allButton:hover #whiteTick {
  display: block;
}

#allButton:hover #purpleTick {
  display: none;
}

#deleteButton:hover #whiteFork {
  display: block;
}

#deleteButton:hover #purpleFork {
  display: none;
}

.tasks-schedules {
  width: 100%;
  height: 40Px;
  /*no*/
  float: left;
  line-height: 40Px;
  /*no*/
  position: relative;
}

.schedules-icon-position {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.schedules-font {
  font-size: 12Px;
  /*no*/
  color: #6f7886;
  position: absolute;
  left: 23Px;
  /*no*/
}

.more-transfers {
  width: 100%;
  position: absolute;
  top: 95Px; /*no*/
}

.operate-option {
  float: left;
}

.coll-enter-active {
  transition: all 0.3s ease;
  height: 250Px;
  /*no*/
  overflow: hidden;
}

.coll-leave-active {
  transition: all 0.3s ease;
  height: 0Px; /*no*/
  overflow: hidden;
}

.coll-enter,
.coll-leave {
  height: 0;
  opacity: 0;
}

.deu-class {
  width: 375Px; /*no*/
}

.other-language {
  width: 365Px; /*no*/
}

.status-txt {
  white-space: nowrap;
}

.tasks-edit-name {
  height: 28Px; /*no*/
  position: relative;
  left: 71Px; /*no*/
  top: -30Px; /*no*/
}

.tasks-lists-name {
  float: left;
  max-width: 122Px; /*no*/
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/workspace/task_list.vue